/**
 * Created by Administrador on 20/7/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('operatorService', operatorService);

    operatorService.$inject = ['$http', 'CONFIG', 'messageService'];

    function operatorService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/operators';
        var service = {
            getOperators: getOperators
        }

        return service;

        function getOperators(){
            return $http.get(urlBase)
                .then(function(response){
                    return response.data._embedded ? response.data._embedded.operators : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };

})();
